import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  getChildRowClassWasteModule(rowtype: any) {
    if (rowtype == 'Compiled Data') {
      return "detailsrow-compiled-data";
    } else if (rowtype == 'ADC Data') {
      return "detailsrow-adc-data";
    } else if (rowtype == 'EHR Data') {
      return "detailsrow-ehr-data";
    }
    else if (rowtype == 'WASTE RECONCILIATION') {
      return "detailsrow-waste-reconcillation";
    }
    else if (rowtype == 'WASTE ASSAY') {
      return "detailsrow-waste-assay";
    }
  }
  groupBy(xs: any, key: any) {
    return xs.reduce(function(rv: any, x: any) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  removeDuplicate2s(list: any){
    const data = {};
    list.forEach((item: any)=>{
      (data as any)[item.label]=item;
    })
    const result: any[] =[]
    Object.keys(data).forEach(item=>result.push((data as any)[item]));
    return result
  }

  removeDuplicates(list: any){
    const data = {};
    list.forEach((item: any)=>{
      (data as any)[item.key]=item;
    })
    const result: any[] =[]
    Object.keys(data).forEach(item=>result.push((data as any)[item]));
    return result
  }

}
